import React from 'react';
import './style.css';
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../../context/AuthContext";

const NotFoundPage = () => {
    const navigate = useNavigate();
    const {user} = useAuth();
    return (
        <>
            <div className="page">
            <div className="container">
                <h1 className="heading">404</h1>
                <p className="paragraph">الصفحة غير موجودة</p>
                <button className="button btn filled" onClick={()=>navigate(`/${user.role}`)}>
                    العودة إلى الصفحة الرئيسية
                </button>
            </div>
            </div>
        </>
    );
};

export default NotFoundPage;
